import elementBase from "./elementBase.js";
import vueStore from "../../config.js";
import * as namespaceStore from "../../namespaceStore.js"
import imageFormat from "../definition/imageFormat.js";

export default class Video extends elementBase {
    objectType = "VideoElement";
    _Path = "";
    Format = imageFormat.Ajuster;
    styleColor = 'rgba(110, 0, 172, 0.49)'; // Bleu marine
    Repeat = true;


    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this._Path = args.path ? this.getIdFromText(args.path, vueStore.getters[namespaceStore.THEME + "/ressourcesByType"]("video")) : "";
        this.Format = args.format ? this.getIdFromText(args.format, imageFormat) : this.getIdFromText("Ajuster", imageFormat);
        this.Repeat = args.repeat ? args.repeat : true;
    }

    static get Name() {
        return "Video";
    }

    get FormatName() {
        const format = imageFormat.find(format => format.idSoft == this.Format);
        return format.name;
    }

    get addedElementShortCutAction() {
        return [
            ...super.addedElementShortCutAction,
            { name: "Path", type: "pathInput", dataType: "string", ressourceType: "video", description: "Changer la video", svgComponentIcon: "imageCarouselIcon" },
        ];
    }

    get shortCut() {
        return [
            ...super.shortCut,
            { name: "Path", type: "pathInput", dataType: "string", ressourceType: "video", description: "Changer la video", svgComponentIcon: "imageCarouselIcon" },
        ];
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "_Path", construct: String, jsType: "String", isRessource: true },
            { propert: "Format", construct: Number, jsType: "Number" },
            { property: "Repeat", construct: Boolean, jsType: "Boolean" }
        ];
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Path", text: "Video", type: "pathInput", dataType: "string", ressourceType: "video" },
            { name: "Format", text: "Format de la video", type: "selectInput", dataType: "string", options: imageFormat, optionsType: "idSoft" },
            { name: "Repeat", text: "Répéter la video", type: "booleanInput", dataType: "boolean" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }

    set Path(value) {
        this._Path = value;
    }

    get Path() {
        const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByIDSoft"](this._Path);
        if (ressource) {
            return ressource.url;
        }
        return this._Path;
    }

    getVideoStyle() {
        let style = {
            width: "100%",
            height: "100%"
        };
        const format = imageFormat.find(format => format.idSoft == this.Format);
        if (format) {
            style = format.action(style, "video");
        }
        else {
            style.objectFit = 'cover';
        }
        return style;
    }

    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            position: 'absolute',
        }
        return style;
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            path: "@" + this._Path + "@",
            format: this.FormatName,
            repeat: this.Repeat,
        };
    }

    toObject(minify = false) {
        let object = {
            ...super.toObject(minify),
            path: this.Path,
            format: this.FormatName,
        };
        return object;
    }
}

